// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3TbXE","shadow":"style_shadow__3DNmP"};